import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {pimText, getValueOfFeature} from '../../../util/values';
import {selectHasBuriedBase, selectHeightDecided, selectIsOnesided, selectModulePosPx} from '../../../selectors';
import {selectSolarLuminarCountValue} from '../../solarSelectors';

@customElement('svg-aeto-lightdistribution')
export class SvgAetoLightdistribution extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 65%;
			height: auto;
		}

		svg {
			height: 100%;
			width: 100%;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.translations = state.productData.translations;
		this.lang = state.status.lang;
		this.status = state.status;
		this.luminarCount = selectSolarLuminarCountValue(this.state);
		this.spread = this.luminarCount === 1 ? 'right' : 'left-right';
		this.lightDistribution = getValueOfFeature('LE_LightDistribution_1', this.decisions) ?? '';
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/aetoLightDistribution.svg';

		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="350" height="140" viewBox="0 0 350 140" text-rendering="geometricPrecision" shape-rendering="geometricPrecision" style="white-space: pre;">
				<g id="LightDistribution" transform="translate(210.824,57.4716) scale(0.43159,0.43159) translate(-132,-91)">
					<ellipse rx="130.829" ry="130.829" fill="#000000" stroke="#848484" stroke-width="3" transform="translate(138.252,95.7509) translate(-7.0851,-7.0851)"/>
					<use href="${svgPath}#${this.lightDistribution}-${this.spread}"></use>
				</g>
				<path id="line" d="M-41,0L-145,0" stroke="#313131" fill="none" stroke-linecap="square" stroke-width="2" transform="translate(62.5,56.5) translate(93,0)"/>
			</svg>
		`;
	}
}
